import { Attributes, LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class InvestorPagedLookup extends LookupBase {
    
    @Attributes.Display("Investor ID")
    public investorId: number = 0;

    public investorName: string = "";

    @Attributes.Display("Legal Entity Type")
    public legalEntityTypeName: string = "";

    public isAuthorised: boolean = false;

    // Client only properties / methods
}